import { createRootRoute } from '@tanstack/react-router';
import { AuthGate } from '../lib/auth-gate.js';
import { companionEnabled } from '../lib/companion-flag.js';
import { NavigationReporter } from '../lib/navigation-reporter.js';
import { RecentProjectsRecorder } from '../lib/recent-projects.js';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-screen bg-surface-app text-text-primary">
      {/* F-016: fire-and-forget presence for the Cowork companion (FR-008);
          renders nothing and can never affect navigation. */}
      {companionEnabled() ? <NavigationReporter /> : null}
      {/* UAT-01: local recency log behind the Recent Projects tab. */}
      <RecentProjectsRecorder />
      <AuthGate />
    </div>
  ),
});
